import { motion } from "framer-motion";
import type { ReactNode } from "react";

export function SectionHeading({
  index,
  kicker,
  title,
  blurb,
}: {
  index: string;
  kicker: string;
  title: ReactNode;
  blurb?: string;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="max-w-2xl"
    >
      <div className="flex items-center gap-3">
        <span className="font-mono text-xs text-signal-500">{index}</span>
        <span className="h-px w-8 bg-signal-500/50" />
        <span className="kicker">{kicker}</span>
      </div>
      <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink-50 sm:text-4xl">
        {title}
      </h2>
      {blurb && <p className="mt-4 text-base leading-relaxed text-ink-300">{blurb}</p>}
    </motion.div>
  );
}
